import {css} from "lit";
import {iconStyles} from "../../common/styles/Icons.js";

export const annotationFreeformStyles = [iconStyles, css`
	.ai-identifier {
		display: flex;
		align-items: center;
		flex-wrap: wrap; /* force the AI diff button onto a second line at small widths */
		gap: 4px;
		margin-bottom: 9px;
		font-size: var(--pn-font-size-small);
	}
	.ai-identifier i {
		font-size: 20px;
	}

	.ai-identifier .ai-label {
		font-weight: 700;
		color: var(--pn-color-ai-purple-dark);
	}

	.ai-identifier .btn-ai-edited {
		font-weight: normal;
		font-style: italic;
		padding: 0;
	}
	.ai-identifier .btn-ai-edited .show-on-hover {
		display: inline-block;
		text-decoration: inherit;
		visibility: hidden;
		width: 0px;
		opacity: 0;
		line-height: 0; /* needed for some reason to prevent */ weird visuals
		transition: width 200ms 50ms, opacity 200ms;
	}

	.annotation-note-container.show-ai-diff .ai-diff {
		display: block;
	}
	.annotation-note-container.show-ai-diff .pn-notes-wrapper {
		display: none;
	}

	.annotation-note-container .ai-diff {
		display: none;
		padding: 4px 6px;
		color: var(--pn-input-text-color);
		font-size: var(--pn-font-size-base);
		line-height: 1.5;
		white-space: pre-wrap;
		user-select: text;
	}

	.annotation-note-container .ai-diff p {
		margin: 0;
	}
	/* Give height (1.5 line-height) to an empty line so that it looks the same as the rich text editors */
	.annotation-note-container .ai-diff p:empty {
		height: 18px;
	}

	.annotation-note-container .ai-diff ins {
		color: var(--pn-outline-annotation-ai-diff-ins-color);
	}

	.annotation-note-container .ai-diff del {
		color: var(--pn-outline-annotation-ai-diff-del-color);
	}

	pn-annotation-footer {
		display: block;
		margin-top: 10px;

		/* TODO */
		.aa-annotation-comment:only-child {
			min-height: 19px;
		}
	}
`];
